import styled, { css } from 'styled-components';

interface IProps {
  sizeDisplay: 'lg' | 'sm' | 'md';
}

export const Container = styled.div<IProps>`
  padding: 5px 14px 5px 0;

  border: 1px solid #cccbcc;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};

  height: 48px;

  ${(props) =>
    props.sizeDisplay === 'lg'
      ? css`
          width: 100%;
        `
      : props.sizeDisplay === 'md'
        ? css`
          width: calc(100% / 2 - 8px);
        `
        : css`
          width: calc(100% / 3 - 11px);
        `}
`;

export const Select = styled.select`
  border: none;
  outline: none;
  width: 100%;

  padding: 7px 2px 7px 16px;

  font-weight: 400;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray[500]};

  // Safari
  /* appearance: none; */
`;
